<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    overlay-opacity="0.85"
    content-class="modern-agency-dialog"
  >
    <v-card class="rounded-xl" elevation="16">
      <!-- Header with gradient background -->
      <v-card-title
        class="editor-header d-flex justify-space-between align-center px-6 py-4"
        v-if="!isCongrats"
      >
        <div class="text-h5 font-weight-bold white--text">
          <v-icon large color="white" class="mr-3">mdi-email-check</v-icon>
          Verify Your Email
        </div>
        <!-- <v-btn
          icon
          @click="onClose"
          class="close-btn"
          color="white"
          depressed
          large
        >
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
      </v-card-title>

      <v-divider v-if="!isCongrats"></v-divider>

      <!-- Congratulations content -->
      <template v-if="isCongrats">
        <v-card-title class="d-flex flex-row justify-center align-center mt-8">
          <v-img src="@/assets/svg/congrates.svg" max-width="200" />
        </v-card-title>
        <v-card-text class="text-center mt-5 text-h5 font-weight-bold primary--text">
          Congratulations!
        </v-card-text>
        <v-card-text class="text-center text-h6">
          You've set up your account.
        </v-card-text>
      </template>

      <!-- Main content -->
      <v-card-text class="px-6 pt-5 pb-1 text-body-1 text--secondary">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
          We're going to send you an email just to make sure that your email
          address is working.
        </div>
      </v-card-text>

      <!-- Error/Success message with smooth transition -->
      <v-expand-transition>
        <v-card-text class="px-6 py-0" v-if="message || errorMessage">
          <v-alert
            :type="messageType"
            class="mb-4 elevation-2"
            transition="scale-transition"
            :icon="
              messageType === 'success'
                ? 'mdi-check-circle'
                : 'mdi-alert-circle'
            "
          >
            {{ message || errorMessage }}
          </v-alert>
        </v-card-text>
      </v-expand-transition>

      <!-- Action buttons -->
      <v-card-actions class="px-6 pb-4 pt-4 d-flex justify-center">
        <v-btn
          color="primary"
          @click="onClose"
          depressed
          width="200"
          class="px-6 save-btn"
          large
          dark
        >
          <v-icon left>mdi-check</v-icon>
          Continue
        </v-btn>
      </v-card-actions>

      <!-- Resend email link -->
      <v-card-text
        class="px-6 pb-6 text-center text--secondary"
        v-if="!isCongrats"
      >
        Didn't receive the email?
        <v-btn
          text
          color="primary"
          class="text-transform-none ml-1"
          @click="onSendEmail"
          :loading="loading"
        >
          Send it again
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function
    },
    isCongrats: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      message: null,
      messageType: "error",
      loading: false,
      errorMessage: null,
      isEmailSent: false
    };
  },
  methods: {
    ...mapActions("volunteer", {
      sendEmailVerification: "sendEmailVerification"
    }),
    onSendEmail() {
      this.loading = true;
      this.sendEmailVerification()
        .then(() => {
          this.message = "Verification email sent successfully!";
          this.messageType = "success";
          this.isEmailSent = true;
        })
        .catch(error => {
          this.message = error.response?.data?.message || "An error occurred";
          this.messageType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapState("auth", {
      profile: "profile"
    })
  },
  mounted() {
    if (!this.isCongrats) {
      this.loading = true;
      this.sendEmailVerification()
        .then(() => {
          this.message = "Verification email sent successfully!";
          this.messageType = "success";
        })
        .catch(error => {
          this.message = error.response?.data?.message || "An error occurred";
          this.messageType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.modern-agency-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.editor-header {
 background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
}

.close-btn {
  transition: all 0.3s ease;
}

.close-btn:hover {
  transform: rotate(90deg);
  background: rgba(255, 255, 255, 0.2) !important;
}

.save-btn {
  box-shadow: 0 4px 12px rgba(58, 123, 213, 0.3) !important;
  transition: all 0.3s ease;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(58, 123, 213, 0.4) !important;
}

.save-btn:active {
  transform: translateY(0);
}

/* Scrollbar styling */
.modern-agency-dialog::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modern-agency-dialog::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modern-agency-dialog::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
  border-radius: 10px;
}

.modern-agency-dialog::-webkit-scrollbar-thumb:hover {
  background: #3a7bd5;
}
</style>